<template>
  <el-table
    :data="tableData"
    style="width: 100%"
    @selection-change="handleSelectionChange"
    height="500"
  >
    <el-table-column type="selection" :selectable="selectable" width="55">
    </el-table-column>
    <el-table-column
      type="index"
      label="序号"
      width="50"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="orderNo"
      label="订单编号"
      width="180"
      align="center"
      show-overflow-tooltip
    ></el-table-column>
    <el-table-column
      label="商品名称"
      prop="goodsName"
      width="200"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column label="价格（元）" prop="price" align="center">
      <template slot-scope="scope">
        {{ scope.row.price === null ? '面议' : scope.row.price }}
        <!-- {{ scope.row.price || '面议' }} -->
      </template>
    </el-table-column>
    <el-table-column label="订单是否用券" prop="couponUse" align="center">
      <template slot-scope="scope">
        {{ scope.row.couponUse | couponStatus }}
      </template>
    </el-table-column>
    <el-table-column
      prop="entName"
      label="企业名称"
      width="200"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
      prop="goodsOrg"
      label="机构名称"
      width="200"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column prop="orderStatus" label="订单状态" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.orderStatus | fileStatus }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="申请兑现状态"
      prop="applyStatus"
      align="center"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        {{ scope.row.applyStatus | applyStatuss }}
      </template>
    </el-table-column>
    <el-table-column
      label="审核兑现状态"
      prop="auditStatus"
      align="center"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span
          :style="{
            background: auditStatusList[scope.row.auditStatus]
          }"
          style="
            width: 8px;
            height: 8px;
            display: inline-block;
            border-radius: 50%;
            margin-right: 5px;
          "
        ></span>
        <span>{{ scope.row.auditStatus | fileAuditStatus }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="取消订单审核"
      prop="applyStatus"
      align="center"
      width="140"
    >
      <template slot-scope="scope">
        <div>
          {{ scope.row.cancelStatus | cancelStatus }}
          <span
            @click="$emit('history', scope.row.id)"
            style="margin-left: 5px; color: #1890ff; cursor: pointer"
            >审核记录</span
          >
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间"
      width="120"
      align="center"
    ></el-table-column>
    <el-table-column label="操作" align="center" width="160">
      <template slot-scope="scope">
        <span
          v-if="
            scope.row.applyStatus !== 1 &&
              (scope.row.applyStatus !== 0 || scope.row.auditStatus !== 3)
          "
          style="margin-right: 10px; color: #1890ff; cursor: pointer"
          @click="orderEdit(scope.row.id)"
          >查看详情</span
        >
        <span
          v-else
          style="margin-right: 10px; color: #1890ff; cursor: pointer"
          @click="edit(scope.row.id, scope.row.auditStatus)"
          >{{ scope.row.auditStatus === 1 ? '审核兑现' : '查看兑现' }}</span
        >
        <span
          style="color: #1890ff; cursor: pointer"
          @click="feedback(scope.row.id)"
          >查看资料</span
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: ['tableData'],
  data() {
    return {
      auditStatusList: [
        '',
        'rgba(0, 119, 255,0.8)',
        'rgb(73, 194, 105)',
        'rgb(251, 76, 76)'
      ]
    }
  },
  filters: {
    couponStatus(val) {
      switch (val) {
        case 0:
          return '否'
        case 1:
          return '是'
        case val:
          return '-'
        default:
          break
      }
    },
    fileStatus(val) {
      switch (val) {
        case 0:
          return '待机构确认'
        case 1:
          return '待企业确认'
        case 2:
          return '待评价'
        case 3:
          return '已完成'
        case 4:
          return '已失效'
        default:
          break
      }
    },
    applyStatuss(val) {
      switch (val) {
        case 0:
          return '未申请'
        case 1:
          return '已申请'
        case val:
          return '-'
        default:
          break
      }
    },
    cancelStatus(val) {
      switch (val) {
        case 1:
          return '待审核'
        case 2:
          return '审核通过'
        case 3:
          return '审核驳回'
        default:
          return '-'
      }
    },
    fileAuditStatus(val) {
      switch (val) {
        case 1:
          return '待审核'
        case 2:
          return '审核通过'
        case 3:
          return '审核驳回'
        case val:
          return '-'
        default:
          break
      }
    }
  },
  methods: {
    // 查看资料
    feedback(id) {
      this.$router.push({ name: 'feedBack', query: { id: id } })
    },
    // 选中
    handleSelectionChange(val) {
      this.$emit('selectChange', val)
    },
    // 设置禁选
    selectable(row) {
      if (row.auditStatus !== 2 && row.orderStatus !== 4) {
        return true
      } else {
        return false
      }
    },
    edit(id, status) {
      this.$router.push({
        name: 'cashoutDetails',
        query: { id: id, name: 'second' }
      })
    },
    orderEdit(id) {
      this.$router.push({ name: 'cashoutDetails', query: { id: id } })
    }
  }
}
</script>

<style></style>
